import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from "react";
import Picker from "react-mobile-picker";
var getOptionGroupsLabel = labeledOptionGroups => {
  if (!labeledOptionGroups || typeof labeledOptionGroups !== "object") {
    return labeledOptionGroups;
  }
  if (Array.isArray(labeledOptionGroups)) {
    return labeledOptionGroups.map(item => transformlabeledOptionGroups(item));
  }
  var newLabeledOptionGroups = {};
  for (var key in labeledOptionGroups) {
    if (key !== "dependency") {
      if (Array.isArray(labeledOptionGroups[key])) {
        if (typeof labeledOptionGroups[key][0] === "object") {
          newLabeledOptionGroups[key] = labeledOptionGroups[key];
          continue;
        } else {
          var transformedArray = labeledOptionGroups[key].map(item => {
            return {
              label: item,
              value: item
            };
          });
          newLabeledOptionGroups[key] = transformedArray;
        }
      }
    }
  }
  return newLabeledOptionGroups;
};
var filterOnDataChange = (currentPickerValue, optionGroups, dependency) => {
  if (dependency && Object.keys(dependency).length) {
    // currently only one dependency is supported
    var dependencyKey = Object.keys(dependency)[0];
    var dependencyValue = currentPickerValue[dependencyKey];
    var dependentOptions = dependency[dependencyKey][dependencyValue] ? dependency[dependencyKey][dependencyValue] : Object.values(dependency[dependencyKey])[0];
    var dependentOptionsKey = Object.keys(dependentOptions[0])[0];
    var allowedOptions = dependentOptions.map(x => x[dependentOptionsKey]);
    var filteredOption = optionGroups[dependentOptionsKey].filter(option => allowedOptions.includes(option.value));
    var newOptionGroups = _objectSpread({}, optionGroups);
    newOptionGroups[dependentOptionsKey] = filteredOption;
    return newOptionGroups;
  } else {
    return optionGroups;
  }
};
export var LabeledPicker = _ref => {
  var {
    labeledOptionGroups,
    height,
    dependency,
    pickerValue,
    setPickerValue
  } = _ref;
  var optionGroups = getOptionGroupsLabel(labeledOptionGroups);
  var [options, setOptions] = useState(optionGroups);
  useEffect(() => {
    var filteredOptions = filterOnDataChange(pickerValue, optionGroups, dependency);
    setOptions(filteredOptions);
    var isPickerValueValid = Object.keys(pickerValue).every(key => filteredOptions[key].map(x => x.value).includes(pickerValue[key]));
    if (!isPickerValueValid) {
      var newPickerValue = _objectSpread({}, pickerValue);
      Object.entries(pickerValue).forEach(_ref2 => {
        var [key, value] = _ref2;
        if (!filteredOptions[key].map(x => x.value).includes(value)) {
          newPickerValue[key] = filteredOptions[key][0].value;
        }
      });
      setPickerValue(newPickerValue);
    }
  }, [pickerValue]);
  return /*#__PURE__*/React.createElement(Picker, {
    value: pickerValue,
    onChange: currentPickerValue => {
      setPickerValue(currentPickerValue);
    },
    wheelMode: "normal",
    height: height
  }, Object.keys(options).map(name => /*#__PURE__*/React.createElement(Picker.Column, {
    key: name,
    name: name
  }, options[name].map(option => /*#__PURE__*/React.createElement(Picker.Item, {
    key: option.value,
    value: option.value
  }, _ref3 => {
    var {
      selected
    } = _ref3;
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(selected ? "uk-text-bold " : "uk-text-muted")
    }, option.label);
  })))));
};